export const headerTextAnimations = {
    delay: 0.5,
    hidden: {
      y: 150,
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      
      
    },
  };
  export const headerCardAnimations = {
    hidden: {
      x: 150,
      opacity: 0,
    },
    visible: {
      x: 0,
      opacity: 1,
    },
  };

  export const offersTitleAnimations = {
    hidden:{
      y: 100,
      opacity: 0,
    },
    visible:{
      y: 0,
      opacity: 1,
    }
  }

  export const offersCardAnimations = {
    hidden:{
      y: 100,
      opacity: 0,
    },
    visible:{
      y: 0,
      opacity: 1,
    }
  }
  export const offersCardTextAnimations = {
    hidden:{
      y: 50,
      opacity: 0,
    },
    visible:{
      y: 0,
      opacity: 1,
    }
  }
  